/**
 * Librería de códigos de Layouts disponibles
 */
export enum Layouts {
    DEFAULT = 1,
    EXCLUSIVE = 2,
  }
  